<table class="table">
	<thead>
		<tr>
			<th scope="col" sortable="name">Nom</th>
			<!-- Boucler sur uniqueVacationTypes pour les en-têtes -->
			<th scope="col">Total de jours de congés restants / accumulés</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let employee of employees; let i = index">
			<td>{{ employee.firstName + ' ' + employee.lastName }}</td>
			<td>
				{{
					employee.totalVacationDaysEntitled - employee.totalVacationDaysTaken
				}}
				/ {{ employee.totalVacationDaysEntitled }}
			</td>
		</tr>
	</tbody>
</table>
